import NavMenu from "components/layout/NavMenu/NavMenu";
import TopMenu from "components/layout/TopMenu/TopMenu";
import React from "react";
import featureFlags from "utils/featureFlags";

const Header: React.FC = () =>
  featureFlags.rebrand ? (
    <>
      {React.createElement("elexon-global-header")}
      <NavMenu />
    </>
  ) : (
    <header>
      <TopMenu />
      <NavMenu />
    </header>
  );

export default Header;
